import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { SITE_NAME } from '../constants/site';
import { CONTACT } from '../constants/contact';
import './PolicyPage.css';

export default function PolicyLayout({ title, children }) {
  return (
    <>
      <Header />
      <main className="dh-policy">
        <div className="dh-container">
          <p className="dh-policy__crumb">
            <Link to="/">{SITE_NAME}</Link> / {title}
          </p>
          <h1>{title}</h1>
          <div className="dh-policy__body">{children}</div>
          <p className="dh-policy__contact">
            Questions? Email <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a> or use live chat
            on this site.
            <br />
            {CONTACT.company} — {CONTACT.address}
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
}
